import React, { useEffect, useState } from 'react';
import PageTitleBanner from './Common/PageTitleBanner';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { useNavigate, useLocation } from 'react-router-dom';

const GalleryDetail = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const [data, setData] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [photoIndex, setPhotoIndex] = useState(0);
    const photoUrl = process.env.REACT_APP_Photo_URL;
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (state != null) {
            EditGallery(state);
        }
    }, [state]);

    const EditGallery = async (id) => {
        try {
            const res = await fetch(`${baseUrl}Photo/GetPhoto`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    TitleID: id,
                    Title: '',
                    TypeID: '',
                    Type: 'Gallery',
                    PaginationID: '-1',
                    PageLength: '',
                }),
            });
            const result = await res.json();
            if (result.status === 1) {
                setData(result.data);
            } else {
                console.error(result.message);
            }
        } catch (error) {
            console.error('Error fetching gallery data:', error);
        }
    };

    const openLightbox = (galleryIndex, imageIndex) => {
        setSelectedImageIndex(galleryIndex);
        setPhotoIndex(imageIndex);
        setModalIsOpen(true);
    };

    const closeLightbox = () => {
        setModalIsOpen(false);
        setSelectedImageIndex(null);
        setPhotoIndex(0);
    };

    const handleLightboxPrev = () => {
        setPhotoIndex((photoIndex + data[selectedImageIndex].ImageDetail.length - 1) % data[selectedImageIndex].ImageDetail.length);
    };

    const handleLightboxNext = () => {
        setPhotoIndex((photoIndex + 1) % data[selectedImageIndex].ImageDetail.length);
    };

    const Oncloseclick = () => {
        navigate('/Gallery');
    };

    return (
        <>
            <PageTitleBanner title={"Gallery Detail"} />
            <div id="content" className="site-content">
                <div className="faq-top secpadd">
                    <div className="container">
                        <div className="fp-testimonials-grid">
                            <button onClick={Oncloseclick} className='fp-btn-2nd readmore ' style={{ float: "right", marginBottom: '2%' }}>
                                <i class="fa fa-arrow-left" aria-hidden="true"></i> Back Gallery
                            </button>
                            <div className="testi-list row" style={{marginLeft:'10px'}}>
                                {data.map((item, galleryIndex) => (
                                    <>
                                        <h4 className='Galleryphone' style={{ marginLeft: '12%', display: 'inline-block' }}>{`${item.Title}`}</h4><br />

                                        <div key={galleryIndex}>
                                            <div className="testi-item col-md-12">
                                                {item.ImageDetail && item.ImageDetail.length > 0 ? (
                                                    item.ImageDetail.map((image, imageIndex) => (
                                                        <div key={imageIndex} style={{ position: 'relative', display: 'inline-block' }}>
                                                            <img
                                                                src={photoUrl + image.Image}
                                                                alt={`Image ${imageIndex + 1}`}
                                                                style={{ width: 290, height: 140, marginRight: '5%', marginBottom: '5%', cursor: 'pointer' }}
                                                                onClick={() => openLightbox(galleryIndex, imageIndex)}
                                                            />
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div>
                                                        <img
                                                            src="Images/Noimage.png"
                                                            alt="No Image Available"
                                                            style={{ width: '80px', height: '80px', marginRight: '5px', border: '1px solid black', color: 'black' }}
                                                        />
                                                    </div>
                                                )}


                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div><br />

            {modalIsOpen && selectedImageIndex !== null && (
                <Lightbox
                    mainSrc={photoUrl + data[selectedImageIndex].ImageDetail[photoIndex].Image}
                    nextSrc={photoUrl + data[selectedImageIndex].ImageDetail[(photoIndex + 1) % data[selectedImageIndex].ImageDetail.length].Image}
                    prevSrc={photoUrl + data[selectedImageIndex].ImageDetail[(photoIndex + data[selectedImageIndex].ImageDetail.length - 1) % data[selectedImageIndex].ImageDetail.length].Image}
                    onCloseRequest={closeLightbox}
                    onMovePrevRequest={handleLightboxPrev}
                    onMoveNextRequest={handleLightboxNext}
                />
            )}
        </>
    );
};

export default GalleryDetail;
